import React from 'react';
import classNames from 'classnames';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const InitializationFormReview = (props) => {
  const {
    manufacturer,
    selectedMachineStyleDisplay,
    selectedControlTier,
    selectedControlTierDisplay,
    selectedMachineSize,
    selectedMachineSizeDisplay,
    selectedMachineName,
    selectedMachineType,
    onBack,
    onNext,
    disableFinalSubmitButton,
    selectedUpperMachineName,
    selectedMachineModel,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Final initialization simulation data</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Please reviews the final details to ensure your selections look good!</p>
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Manufacturer: </p>
            <p>{manufacturer}</p>
          </div>
          {selectedMachineStyleDisplay && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Machine Style: </p>
              <p>{selectedMachineStyleDisplay}</p>
            </div>
          )}
          {selectedControlTier && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Control Tier: </p>
              <p>{selectedControlTierDisplay}</p>
            </div>
          )}
          {selectedMachineSize && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Machine Size: </p>
              <p>{selectedMachineSizeDisplay} lbs</p>
            </div>
          )}
          {selectedMachineModel && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Machine Model: </p>
              <p>{selectedMachineModel}</p>
            </div>
          )}
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Machine Name: </p>
            <p>{selectedMachineName}</p>
          </div>
          {selectedUpperMachineName && (
            <div className={styles.formReviewRowLayout}>
              <p className={styles.formLabel}>Upper Machine Name: </p>
              <p>{selectedUpperMachineName}</p>
            </div>
          )}
          <div className={styles.formReviewRowLayout}>
            <p className={styles.formLabel}>Machine Type: </p>
            <p>{selectedMachineType}</p>
          </div>
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !disableFinalSubmitButton,
          })}
          disabled={!disableFinalSubmitButton}
          onClick={onNext}
        >
          Submit
        </button>
      </footer>
    </>
  );
};

export default InitializationFormReview;
